import type { SVGProps } from 'react';

export const ThumbsDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M3.66623 15.9998H5.66622C5.958 15.9998 6.23744 15.9459 6.49512 15.8477C6.60894 16.0437 6.74141 16.23 6.89156 16.4038L12.5769 22.9864C12.7715 23.2118 13.0502 23.3331 13.3342 23.3331C13.4849 23.3331 13.6382 23.2984 13.7809 23.2278C15.3769 22.4291 16.1155 20.5638 15.4995 18.8891L14.4355 15.9998H18.8702C20.0169 15.9998 21.0755 15.4784 21.7755 14.5691C22.4742 13.6598 22.7075 12.5038 22.4142 11.3945H22.4128L20.8249 5.39447C20.3995 3.78781 18.9409 2.66648 17.2795 2.66648H9.66622C8.81466 2.66648 8.02984 2.95826 7.40665 3.44721C6.97904 2.96837 6.35725 2.66647 5.66622 2.66647H3.66623C2.37957 2.66647 1.3329 3.71314 1.3329 4.9998V13.6664C1.3329 14.9531 2.37957 15.9998 3.66623 15.9998ZM3.3329 4.9998C3.3329 4.8158 3.48223 4.66647 3.66623 4.66647H5.66622C5.85022 4.66647 5.99956 4.8158 5.99956 4.9998V13.6664C5.99956 13.8504 5.85022 13.9998 5.66622 13.9998H3.66623C3.48223 13.9998 3.3329 13.8504 3.3329 13.6664V4.9998Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
